package one.healthium.health_advice.domain

import kotlinx.serialization.Serializable

@Serializable
data class HealthAdviceModel(
    val sets: List<HealthAdviceRulesSet>
)

@Serializable
data class HealthAdviceRulesSet(
    val minLevels: RulesSetLevels,
    val fallbackMessage: String? = null,
    val rules: List<HealthAdviceRule>,
)

@Serializable
data class RulesSetLevels(
    val minValue: Int,
    val maxValue: Int? = null,
    val count: Int,
) {
    val maxValueOrDefault = maxValue ?: Int.MAX_VALUE
}

@Serializable
data class HealthAdviceRule(
    val message: String,
    val conditions: List<HealthAdviceRuleCondition> = emptyList(),
)

@Serializable
data class HealthAdviceRuleCondition(
    val symptom: String,
    val value: Int,
)